export default {"src":"/_next/static/media/logo_vectorized.5c81e218.svg","height":668,"width":718,"blurWidth":0,"blurHeight":0};